var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-apploye-logo-sidebar-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "apploye-logo-sidebar-2",
    clipPath: "url(#clip-apploye-logo-sidebar-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36028",
    "data-name": "Rectangle 36028",
    width: 46,
    height: 46,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73818",
    "data-name": "Path 73818",
    d: "M44.651,37.248c-8.676.455-13.357-1.38-16.2-4.278C22.11,26.523,24.96,14.8,13,11.592a27.225,27.225,0,0,0-6.453-.82,15.6,15.6,0,0,1,24.79,3.16h0l.748,1.507C42.465,36.248,44.651,37.248,44.651,37.248ZM20.061,17.261a12.844,12.844,0,0,0-7.6-4.945,27.109,27.109,0,0,0-6.4-.768A15.607,15.607,0,0,0,13.6,36.422h.017c-7.287-8.525.1-21,6.458-19.131Zm2.264,4.661-.116-.055a3.767,3.767,0,0,1-.191.58,3.922,3.922,0,0,1-3.612,2.394,3.965,3.965,0,0,1-.67-.058,3.913,3.913,0,0,1-3.113-4.89c-2.319,2.783-3.9,6.232-3.235,10.282a15.01,15.01,0,0,0,3.16,6.421l.157.191h0a15.653,15.653,0,0,0,13.314-3.223h0c-2.768-2.128-5.864-9.171-5.693-11.641Z",
    transform: "translate(0.694 -1.144)",
    fill: "#6776cb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33899",
    "data-name": "Group 33899",
    transform: "translate(0.655 23.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_35998",
    "data-name": "Rectangle 35998",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#b48963",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.125,
    height: 18.125,
    rx: 9.062,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17.125,
    height: 17.125,
    rx: 8.562,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33790",
    "data-name": "Group 33790",
    transform: "translate(1.748 1.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33741",
    "data-name": "Group 33741",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33756",
    "data-name": "Rectangle 33756",
    width: 2.601,
    height: 2.601,
    transform: "translate(5.802 6.403)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29204",
    "data-name": "Group 29204"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11001",
    "data-name": "Ellipse 11001",
    cx: 0.7,
    cy: 0.7,
    r: 0.7,
    transform: "translate(10.604 5.602)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11002",
    "data-name": "Ellipse 11002",
    cx: 0.7,
    cy: 0.7,
    r: 0.7,
    transform: "translate(9.404 3.602)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11003",
    "data-name": "Ellipse 11003",
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "translate(11.205 4.002)",
    fill: "#b48963",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11004",
    "data-name": "Ellipse 11004",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(12.605 5.402)",
    fill: "#b48963",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11005",
    "data-name": "Ellipse 11005",
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "translate(12.205 7.003)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11006",
    "data-name": "Ellipse 11006",
    cx: 0.3,
    cy: 0.3,
    r: 0.3,
    transform: "translate(13.806 6.403)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11020",
    "data-name": "Ellipse 11020",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(2.801 1.401)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11021",
    "data-name": "Ellipse 11021",
    cx: 0.5,
    cy: 0.5,
    rx: 0.5,
    ry: 0.5,
    transform: "translate(1.601 2.401)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11012",
    "data-name": "Ellipse 11012",
    cx: 0.4,
    cy: 0.4,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(10.504 1)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11013",
    "data-name": "Ellipse 11013",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(9.004 0.4)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11014",
    "data-name": "Ellipse 11014",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(7.603 1)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11015",
    "data-name": "Ellipse 11015",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(6.603)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11016",
    "data-name": "Ellipse 11016",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(5.002 0.4)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11017",
    "data-name": "Ellipse 11017",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(4.202 1.601)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11018",
    "data-name": "Ellipse 11018",
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "translate(5.802 1.601)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11019",
    "data-name": "Ellipse 11019",
    cx: 0.7,
    cy: 0.7,
    rx: 0.7,
    ry: 0.7,
    transform: "translate(7.403 2.601)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11022",
    "data-name": "Ellipse 11022",
    cx: 0.7,
    cy: 0.7,
    r: 0.7,
    transform: "translate(3.001 4.602)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11023",
    "data-name": "Ellipse 11023",
    cx: 0.7,
    cy: 0.7,
    r: 0.7,
    transform: "translate(2.401 6.803)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11024",
    "data-name": "Ellipse 11024",
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "translate(1.401 5.402)",
    fill: "#b48963",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11025",
    "data-name": "Ellipse 11025",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(0.6 7.203)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11026",
    "data-name": "Ellipse 11026",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(0 8.604)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11027",
    "data-name": "Ellipse 11027",
    cx: 0.3,
    cy: 0.3,
    r: 0.3,
    transform: "translate(0.6 10.004)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11031",
    "data-name": "Ellipse 11031",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(1.801 12.005)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11033",
    "data-name": "Ellipse 11033",
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "translate(3.201 11.205)",
    fill: "#b48963",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11037",
    "data-name": "Ellipse 11037",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(4.402 12.605)",
    fill: "#b48963",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11032",
    "data-name": "Ellipse 11032",
    cx: 0.4,
    cy: 0.4,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(3.201 13.005)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11043",
    "data-name": "Ellipse 11043",
    cx: 0.4,
    cy: 0.4,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(10.604 13.005)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11044",
    "data-name": "Ellipse 11044",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(10.805 11.405)",
    fill: "#b48963",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11046",
    "data-name": "Ellipse 11046",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(11.405 10.004)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11047",
    "data-name": "Ellipse 11047",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(12.205 11.605)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11038",
    "data-name": "Ellipse 11038",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(5.402 13.806)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11039",
    "data-name": "Ellipse 11039",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(6.803 14.006)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11030",
    "data-name": "Ellipse 11030",
    cx: 0.5,
    cy: 0.5,
    rx: 0.5,
    ry: 0.5,
    transform: "translate(1.801 10.404)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11028",
    "data-name": "Ellipse 11028",
    cx: 0.5,
    cy: 0.5,
    rx: 0.5,
    ry: 0.5,
    transform: "translate(1.601 8.604)",
    fill: "#b48963",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11029",
    "data-name": "Ellipse 11029",
    cx: 0.7,
    cy: 0.7,
    r: 0.7,
    transform: "translate(3.201 9.204)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11034",
    "data-name": "Ellipse 11034",
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "translate(5.002 10.805)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11035",
    "data-name": "Ellipse 11035",
    cx: 0.7,
    cy: 0.7,
    rx: 0.7,
    ry: 0.7,
    transform: "translate(7.403 11.005)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11036",
    "data-name": "Ellipse 11036",
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "translate(6.003 12.405)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11040",
    "data-name": "Ellipse 11040",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(7.803 13.005)",
    fill: "#b48963",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11041",
    "data-name": "Ellipse 11041",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(9.204 13.606)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11042",
    "data-name": "Ellipse 11042",
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "translate(9.204 11.805)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11008",
    "data-name": "Ellipse 11008",
    cx: 0.4,
    cy: 0.4,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(13.206 4.002)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11009",
    "data-name": "Ellipse 11009",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(12.205 2.601)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11010",
    "data-name": "Ellipse 11010",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(10.604 2.401)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11011",
    "data-name": "Ellipse 11011",
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(9.004 1.801)",
    fill: "#b48963",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11007",
    "data-name": "Ellipse 11007",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(13.806 8.003)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11949",
    "data-name": "Ellipse 11949",
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(9.553 10.004)",
    fill: "#b48963"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.730e71ae2ffdc24786a1814f7c41eb7e.svg";
export { ForwardRef as ReactComponent };